import React, { useState, useEffect } from "react";
import { Layout, Menu, Dropdown, Avatar } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { RxDashboard } from "react-icons/rx";
import { MdFeedback ,MdOutlineNotificationsActive  } from "react-icons/md";
import { GiBookshelf, GiBlackBook } from "react-icons/gi";
import { RxDropdownMenu } from "react-icons/rx";
import { BsStars } from "react-icons/bs";
import { SiBookstack } from "react-icons/si";
import { RiLockPasswordLine } from "react-icons/ri";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FaUsers } from "react-icons/fa";
import { IoLogOut } from "react-icons/io5";
import Swal from "sweetalert2";
import "./AppLayout.css";

const { Header, Sider, Content } = Layout;

// const getFullName = (u = {}) =>
//   [u.first_name, u.middle_name, u.last_name].filter(Boolean).join(" ").trim();

const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [userState, setUserState] = useState(() =>
    JSON.parse(localStorage.getItem("user") || "{}")
  );
  const navigate = useNavigate();
  const location = useLocation();

  const toggle = () => {
    setCollapsed(!collapsed);
  };

const handleLogout = async () => {
  const res = await Swal.fire({
    icon: "warning",
    title: "Log out?",
    text: "You will be signed out from this device.",
    showCancelButton: true,
    confirmButtonText: "Log out",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#ef4444",
  });

  if (res.isConfirmed) {
    localStorage.clear();
    window.location.replace("/");
  }
};

  const user = userState || {};
  const fullName = [user.first_name, user.middle_name, user.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();

  const roleLabel =
    user.role === "MA"
      ? "Admin"
      : user.role === "A"
      ? "Admin"
      : user.role === "U"
      ? "Admin"
      : "";

  useEffect(() => {
    const refreshUser = () => {
      const u = JSON.parse(localStorage.getItem("user") || "{}");
      setUserState(u);
    };

    // fired by Profile page after successful update:
    // window.dispatchEvent(new Event("user-updated"))
    window.addEventListener("user-updated", refreshUser);

    // also update if localStorage changes in another tab
    const onStorage = (e) => {
      if (e.key === "user") refreshUser();
    };
    window.addEventListener("storage", onStorage);

    // initial sync in case user was set before mount
    refreshUser();

    return () => {
      window.removeEventListener("user-updated", refreshUser);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

const loginUser = JSON.parse(localStorage.getItem("login_user") || "{}");
const lastLogin = loginUser?.last_login || "-";

  // Format helper
  const formatLastLogin = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString.replace(" ", "T")); // ensure valid ISO

    const time = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    const formattedDate = date.toLocaleDateString([], {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    return `${time} · ${formattedDate}`;
  };

  const last_login = formatLastLogin(user.last_login);

  const profileMenu = (
    <Menu>
      <Menu.Item
        key="profile"
        icon={<UserOutlined />}
        onClick={() => navigate("/my-profile")}
      >
        My Profile
      </Menu.Item>

      <Menu.Item
        key="change-password"
        icon={<RiLockPasswordLine />}
        onClick={() => navigate("/change-password")}
      >
        Change Password
      </Menu.Item>

      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  const menuItems = [
    {
      key: "/dashboard",
      icon: <RxDashboard />,
      label: "Dashboard",
      path: "/dashboard",
    },
    {
      key: "/specialities",
      icon: <BsStars />,
      label: "Specialities",
      path: "/specialities",
    },
    {
      key: "/module",
      icon: <GiBookshelf />,
      label: "Module",
      path: "/module",
    },
    {
      key: "/sub-module",
      icon: <GiBlackBook />,
      label: "Sub Module",
      path: "/sub-module",
    },
    {
      key: "/chapter",
      icon: <SiBookstack />,
      label: "Chapter",
      path: "/chapter",
    },
    // {
    //   key: "/chapter-slides",
    //   icon: <MdOutlineFolderSpecial />,
    //   label: "Chapter Slides",
    //   path: "/chapter-slides",
    // },
    {
      key: "/mcqs",
      icon: <RxDropdownMenu />,
      label: "MCQS",
      path: "/mcqs",
    },
    {
      key: "/feedbacks",
      icon: <MdFeedback />,
      label: "Feedbacks",
      path: "/feedbacks",
    },
      {
      key: "/notification",
      icon: <MdOutlineNotificationsActive />,
      label: "Notification",
      path: "/notification",
    },
    {
      key: "/users",
      icon: <FaUsers />,
      label: "Users",
      path: "/users",
    },

    {
      key: "logout",
      icon: <IoLogOut />,
      label: "Logout",
      onClick: handleLogout,
    },
  ];

  // below: const location = useLocation();
  const activeMenuKey = React.useMemo(() => {
    const path = location.pathname;

    // ✅ Map /chapter-slides (and its children) to /chapter
    if (path.startsWith("/chapter-slides")) return "/chapter";

    // otherwise use the exact path (or you can add more mappings here)
    return path;
  }, [location.pathname]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className="ant-layout-sider"
      >
        <div
          className="logo"
          onClick={() => navigate("/dashboard")}
          style={{ cursor: "pointer" }}
        >
          <img
            src={collapsed ? "/logo-pa.png" : "/physio-logo.png"}
            alt="Physio Logo"
            style={{
              width: collapsed ? "40px" : "120px",
              transition: "all 0.3s ease",
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>

        <Menu theme="dark" mode="inline" selectedKeys={[activeMenuKey]}>
          {menuItems.map((item) => (
            <Menu.Item
              key={item.key}
              icon={item.icon}
              onClick={() =>
                item.onClick ? item.onClick() : item.path && navigate(item.path)
              }
            >
              <div className="menu-label-with-arrow">
                <span>{item.label}</span>
                <img src="/arrow-left.png" alt="arrow" className="menu-arrow" />
              </div>
            </Menu.Item>
          ))}
        </Menu>

        <div style={{ textAlign: "center" }} className="sidebar-bottom-img">
          <img
            src="/portal-circle.webp"
            alt="Sidebar Bottom"
            style={{ width: "100%" }}
          />
        </div>
      </Sider>

      <Layout>
        <Header
          style={{
            // background: "#fff",
            // padding: "0 10px",
            marginLeft: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="header-main"
        >
          <div
            className="custom-trigger"
            style={{ fontSize: 18, cursor: "pointer" }}
            onClick={toggle}
          >
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </div>

          <Dropdown overlay={profileMenu} trigger={["click"]}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
              }}
            >
              <div
                style={{ color: "#5a355a", textAlign: "left", lineHeight: 1.2 }}
                className="header-admin-name"
              >
                <div className="user-name-header" style={{ fontWeight: 700 }}>
                  {fullName}{" "}
                  <p
                    style={{
                      fontSize: 12,
                      opacity: 0.85,
                      fontWeight: 600,
                      margin: 0,
                    }}
                  >
                    ({roleLabel})
                  </p>
                </div>

                <div style={{ fontSize: 11, opacity: 0.7, marginTop: 2 }}>
                  Last login: {lastLogin || "-"}
                </div>
              </div>

                <Avatar
                className="avatar-main"
                src={user.profile_image_url || undefined}
                icon={!user.profile_image_url && <UserOutlined />}
                alt={fullName || "User"}
              />
            </div>
          </Dropdown>
        </Header>

        <Content style={{ padding: 12 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
